$(function () {

    return;

    var subSectionNav = $('.sub-section_navigation');

    if (subSectionNav.length < 1) {
        return;
    }

    subSectionNav.find('nav').align({
        selector: 'ul li'
    });

});